import * as React from "react";

import { getOrCreateGlobalContext, CONTEXT_KEYS } from "../utils";

interface ProviderProps {
	children: JSX.Element | null;
}

type ProviderValue = [
	Record<string, unknown>,
	(state: Record<string, unknown>) => void,
];

const SessionContext = getOrCreateGlobalContext<ProviderValue>(
	CONTEXT_KEYS.SESSION,
	[{}, () => null],
);

const SessionProvider = (props: ProviderProps) => {
	const { children } = props;
	const value = useSessionProvider();

	return (
		<SessionContext.Provider value={value}>{children}</SessionContext.Provider>
	);
};

const useSessionProvider = (): ProviderValue => {
	const [config, setConfig] = React.useState({});
	const changeConfig = (value: { [key: string]: unknown }) =>
		setConfig((state) => ({ ...state, ...value }));
	return [config, changeConfig];
};

export { SessionContext, SessionProvider };
